import { Chain } from 'wagmi';
import { mainnet, arbitrum, base } from 'viem/chains';

export const getChain = (chainId: Chain['id']) => {
  const chains = [mainnet, arbitrum, base];

  return chains.find((c) => c.id === chainId) || mainnet;
};
